<template>
    <div class="p-5">
        <div class="container">
            <h1 class="is-size-4 has-text-weight-medium mb-4">
                Registrar empresa
            </h1>
            <div class="columns">
                <div class="column is-three-quarters is-relative">
                    <b-loading
                        :is-full-page="false"
                        v-model="loading"
                    ></b-loading>
                    <register-data-form
                        :empresa="form.empresa"
                        :trabajador="form.trabajador"
                        :buttonEnabled="false"
                    />
                </div>
                <div class="is-divider-vertical"></div>
                <div class="column">
                    <h3 class="is-size-6 mb-3">
                        Resumen
                        <router-link :to="{ name: 'account-elegir-plan' }"
                            >(modificar)</router-link
                        >
                    </h3>
                    <ul>
                        <li>
                            <div
                                class="is-flex is-justify-content-space-between"
                            >
                                <b>{{ info.description }} (x1 mes)</b>
                                <b class="has-text-primary"
                                    >S/. {{ info.amount }}</b
                                >
                            </div>
                        </li>
                    </ul>
                    <div class="is-divider"></div>
                    <div class="is-flex is-justify-content-space-between">
                        <b>TOTAL</b>
                        <b class="has-text-primary">S/. {{ info.amount }}</b>
                    </div>
                    <br />
                    <b-checkbox v-model="confirm" required>
                        <small
                            >He leído y acepto los
                            <a
                                href="https://www.gestionhumana.app/legal/terminos-y-condiciones"
                                target="_blank"
                                ><small>Términos y Condiciones</small></a
                            ></small
                        >
                    </b-checkbox>
                    <br /><br />
                    <b-button
                        :disabled="!activePaymentButton"
                        @click="handleFinish"
                        type="is-primary"
                        expanded
                    >
                        Pagar
                    </b-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import RegisterDataForm from '@/components/Account/RegisterDataForm.vue';
import Message from '@/utils/Message';
import { API_URL, NIUBIZ_LIBRARY_URL } from '@/config';

export default {
    components: {
        RegisterDataForm,
    },
    data() {
        return {
            VisanetCheckout: window.VisanetCheckout,
            loading: false,
            confirm: false,
            info: {
                sessiontoken: '',
                channel: 'web',
                merchantid: '', // Variable
                purchasenumber: '', // # de max 12 digitos
                amount: 0,
                expirationminutes: '20',
                timeouturl: 'about:blank',
                merchantlogo: '#',
                formbuttoncolor: '#05036E',
                action: '',
                description: '',
            },
            form: {
                empresa: {
                    razon_social: '',
                    ruc: '',
                    pais_id: '',
                    direccion: '',
                    img: '',
                },
                trabajador: {
                    nombre: '',
                    apellido_paterno: '',
                    apellido_materno: '',
                    fecha_nacimiento: '',
                    direccion: '',
                },
            },
        };
    },
    computed: {
        selectedPlan() {
            return this.$store.state.planes.selected;
        },
        activePaymentButton() {
            if (this.selectedPlan.precio !== 0) {
                return this.confirm && this.info.sessiontoken !== '';
            } else {
                return this.confirm;
            }
        },
        dataEncoded() {
            const data = {
                form: this.form,
                amount: this.info.amount,
                purchaseNumber: this.info.purchasenumber,
            };
            return btoa(JSON.stringify(data));
        },
    },
    created() {
        // Agregar <script/> con el url de NIUBIZ en el <head/> de la pagina
        let scriptTag = document.createElement('script');
        scriptTag.setAttribute('src', NIUBIZ_LIBRARY_URL);
        document.head.appendChild(scriptTag);
    },
    async mounted() {
        // Si no hay algun plan elegido de antemano redirige a la pagina para elegir planes
        if (!this.selectedPlan.id) {
            this.$router.push({ name: 'account-elegir-plan' });
            return;
        }

        // Guardar la informacion del precio y la descripcion
        this.info.amount = this.selectedPlan.precio;
        this.info.description = this.selectedPlan.descripcion;

        // Si el plan a pagar no tiene costo no ejecutar pasarela de pagos
        if (this.selectedPlan.precio !== 0) {
            // Obtener sessiontoken
            await this.getSessionToken();
        } else {
            return;
        }
    },
    methods: {
        isInvalidForm() {
            const empresaFormValid = this.hasEmptyFields(this.form.empresa);
            const trabajadorFormValid = this.hasEmptyFields(
                this.form.trabajador
            );
            return empresaFormValid || trabajadorFormValid;
        },
        async getSessionToken() {
            this.loading = true;
            try {
                const { sessiontoken, merchantid, purchasenumber } =
                    await this.$store.dispatch('pagos/sessionToken', {
                        plan_id: this.selectedPlan.id,
                    });
                this.info.sessiontoken = sessiontoken;
                this.info.merchantid = merchantid;
                this.info.purchasenumber = purchasenumber;
            } catch (err) {
                Message.showErrorMessage(this, err.message);
            } finally {
                this.loading = false;
            }
        },
        async handleFinish() {
            if (this.selectedPlan.precio !== 0) {
                this.openPaymentForm();
            } else {
                this.sendForm();
            }
        },
        async sendForm() {
            this.loading = true;
            try {
                const res = await this.$store.dispatch('empresas/create', {
                    ...this.form,
                });
                Message.showSuccessMessage(this, res.message);
                setTimeout(() => {
                    window.location.replace('/account');
                }, 2000);
            } catch (err) {
                Message.showErrorMessage(this, err.message);
            } finally {
                this.loading = false;
            }
        },
        openPaymentForm() {
            this.info.action = `${API_URL}/pagos/procesar?de=${this.dataEncoded}`;
            this.VisanetCheckout.configure(this.info);
            this.VisanetCheckout.open();
        },
    },
};
</script>
